import { Component, OnInit } from '@angular/core';
import { IntranetNewService } from 'src/app/api/intranet-new.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-configuracion-general',
  templateUrl: './configuracion-general.component.html',
  styleUrls: ['./configuracion-general.component.sass']
})
export class ConfiguracionGeneralComponent implements OnInit {

  loading = true;
  saving = false;
  activeTab = 'empresa';

  config: any = {
    SAP: {
      SERVER: '', SERVER_SDL: '', SERVER_LICENCIA: '',
      DATA_BASE_TYPE: '', DATA_BASE: '', DATA_BASE_USER: '', DATA_BASE_PASS: '',
      DATA_BASE_CONECTION_STRING: '', USER: '', PASS: ''
    },
    CORREO: {
      CORREO: '', PASS: '', SMTP: '', PUERTO: 587, SSL: true,
      REMITENTE: '', REMITENTE_NOMBRE: ''
    },
    EMPRESA: {
      RUT: '', NOMBRE: '', URL: '', TELEFONO: '', DIRECCION: ''
    },
    PAGINA: {
      RUTA_IMAGEN_LOGO: '', RUTA_IMAGEN_LAYOUT: '', RUTA_IMAGEN_USER_NOT_FOUND: ''
    },
    INDESAD: {
      API_KEY: '', API_LOGINSA: '', LICENCIAS: 0,
      numeracionDocumentoPreliminal: 1000,
      urlAPILoginsa: '', usuarioLoginsa: '', passLoginsa: '',
      whseid: '', storerkey: ''
    },
    IsSystemBlocked: false
  };

  // Password visibility toggles
  showPassSAP = false;
  showPassDB = false;
  showPassCorreo = false;
  showPassLoginsa = false;

  // SAP reconnect state
  reconnecting = false;
  sapStatus: { connected: boolean; error?: string } | null = null;

  constructor(private _apiV2: IntranetNewService) {}

  ngOnInit(): void {
    this.cargarConfiguracion();
  }

  async cargarConfiguracion() {
    this.loading = true;
    try {
      const res: any = await this._apiV2.ObtenerConfiguracion();
      if (res?.estado && res.resultado) {
        // Merge with defaults to handle missing fields
        this.config = this.mergeDeep(this.config, res.resultado);
      }
    } catch (error) {
      
      Swal.fire('Error', 'No se pudo cargar la configuración', 'error');
    }
    this.loading = false;
  }

  async guardar() {
    const result = await Swal.fire({
      title: '¿Guardar cambios?',
      text: 'Se actualizará la configuración del sistema. Algunos cambios pueden requerir reiniciar la API.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    });
    if (!result.isConfirmed) return;

    this.saving = true;
    try {
      Swal.fire({ title: 'Guardando...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      const res: any = await this._apiV2.GuardarConfiguracion(this.config);
      Swal.close();
      if (res?.estado) {
        Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 })
          .fire({ icon: 'success', title: res.mensaje || 'Configuración guardada' });
      } else {
        Swal.fire('Error', res?.mensaje || 'No se pudo guardar', 'error');
      }
    } catch (e) {
      Swal.close();
      Swal.fire('Error', 'Error de conexión al guardar', 'error');
    }
    this.saving = false;
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }

  async reiniciarConexionSAP() {
    const confirm = await Swal.fire({
      title: '¿Reiniciar conexión SAP?',
      html: 'Se cerrará la sesión actual y se reconectará con las credenciales <b>guardadas</b> en la configuración.<br><br><small class="text-muted">Si cambiaste credenciales, guarda primero antes de reiniciar.</small>',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, reiniciar',
      cancelButtonText: 'Cancelar'
    });
    if (!confirm.isConfirmed) return;

    this.reconnecting = true;
    this.sapStatus = null;
    try {
      Swal.fire({ title: 'Reconectando a SAP...', text: 'Cerrando sesión anterior y abriendo nueva conexión', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      const res: any = await this._apiV2.ReconexionSAP();
      Swal.close();
      if (res?.estado && res.resultado) {
        this.sapStatus = {
          connected: res.resultado.estadoConexionSAP,
          error: res.resultado.mensajeError
        };
        if (this.sapStatus.connected) {
          Swal.fire({ icon: 'success', title: '¡Conexión exitosa!', text: `Conectado a: ${res.resultado.credenciales?.DATA_BASE || 'N/A'}`, timer: 3000, showConfirmButton: false });
        } else {
          Swal.fire('Error de conexión', this.sapStatus.error || 'No se pudo conectar a SAP', 'error');
        }
      } else {
        Swal.fire('Error', res?.mensaje || 'Error al reiniciar conexión', 'error');
      }
    } catch (e) {
      Swal.close();
      Swal.fire('Error', 'No se pudo comunicar con la API', 'error');
    }
    this.reconnecting = false;
  }

  // Deep merge source into target (keeps defaults for missing fields)
  private mergeDeep(target: any, source: any): any {
    const result = { ...target };
    for (const key of Object.keys(source)) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key]) && key !== '_id') {
        result[key] = this.mergeDeep(target[key] || {}, source[key]);
      } else {
        result[key] = source[key];
      }
    }
    return result;
  }
}
